export const locStor = {
  get: (keyParam) => {
    const data = localStorage.getItem(keyParam);
    const parsedData = JSON.parse(data);
    return parsedData;
  },
  set: (keyParam, dataParam) => {
    const parsedData = JSON.stringify(dataParam);
    return localStorage.setItem(keyParam, parsedData);
  },
  delete: (keyParam) => {
    localStorage.removeItem(keyParam)
  },
  //   replace: (keyParam, dataParam) => {
  // 	return localStorage.setItem(keyParam, dataParam);
  //   }
};
